import React from 'react';
import TabsHelper from "../TabsHelper";
import {Button} from "antd";
import AdminTables from "./AdminTables";
import AdminConfigurations from "./AdminConfigurations";
import PrivateRoute from "../Main/PrivateRoute";
import {connect} from "react-redux";
import issueCRL from "../../actions/issueCRL";
import getSystemInformation from "../../actions/getSystemInformation";
import getSystemLog from "../../actions/getSystemLog";
import modalShow from "../../actions/modalShow";
import moveCerts from "../../actions/moveCerts";
import modalDismiss from "../../actions/modalDismiss";
import {MESSAGE_MODAL, SYSTEM_INFORMATION_MODAL} from "../Modal/types";
import languages from "../../language/languages";
import testSMTP from "../../actions/testSMTP";

class Admin extends React.Component {

  componentDidMount() {
    
  }

    moveCerts = () =>
    {
        let general=this;
        let message=languages[this.props.language].confirmMove;
        this.props.modalShow({
            modalType: MESSAGE_MODAL,
            modalProps: {footer: null, title: languages[this.props.language].confirmTitle},
            componentProps: {onOK:() =>{general.props.modalDismiss();general.props.moveCerts();},btnOK:languages[this.props.language].btnOK,btnCancel:languages[this.props.language].btnCancel,onCancel: () =>{general.props.modalDismiss()},message:message}
        });
    };
  
  afterInfo = (report) =>
  {
  this.props.modalShow({
      modalType: SYSTEM_INFORMATION_MODAL,
      modalProps: {footer: null, title: languages[this.props.language].system_info},
      componentProps: {language: this.props.language, systemReport: report, getSystemLog:this.props.getSystemLog}
    });
  };

  showSystemModal = () =>
  {
      this.props.getSystemInformation(this.afterInfo);
  };
  

  tabProps(){
    return (
        {
          number: 2,
          titles:[
            languages[this.props.language].tables_tab,
              languages[this.props.language].config_tab
          ],
          keys:[
            'tables',
            'configuration'
          ],
          content: [
            AdminTables,
            AdminConfigurations
          ],
          tabProps: [
            {},
            {},
            {},
            {}
          ]
        }
    );
  };

  render() {
    return (
        <div className="card-container h-100 p-20 tabs-container">
          <h2>{languages[this.props.language].admin_title}</h2>
            {this.props.isRA?'':<Button style={{marginRight:10, marginBottom:10}} htmlType={'button'} type={'primary'} onClick={this.props.issueCRL}>{languages[this.props.language].issueCRL}</Button>}
            <Button style={{marginRight:10, marginBottom:10}} htmlType={'button'} type={'primary'} onClick={this.moveCerts}>{languages[this.props.language].moveCerts}</Button>
            <Button style={{marginRight:10}} htmlType={'button'} type={'primary'} onClick={this.showSystemModal}>{languages[this.props.language].system_info}</Button>
            <Button style={{marginRight:10}} htmlType={'button'} type={'primary'} onClick={this.props.testSMTP}>{languages[this.props.language].testSMTP}</Button>
            <br/>
            <br/>
          <TabsHelper {...this.tabProps()}/>
        </div>
    );
  };

}
const mapStateToProps = state => {
  return {
    language: state.auth.language,
      isRA: state.auth.isRA
  };
};


export default PrivateRoute(connect(mapStateToProps, {modalShow,modalDismiss, getSystemInformation,issueCRL,moveCerts,testSMTP,getSystemLog})(Admin));